import { IDeleteDiarioObraUseCase } from "../../../presentation/useCases/delete/delete_diario_obras_use_case";
import { IDiarioObraRepository } from "../../repositories/diario_obra_repository";

// DeleteDiarioObraUseCase

export class DeleteDiarioObraUseCase implements IDeleteDiarioObraUseCase {
  constructor(private readonly repository: IDiarioObraRepository) {}

  async deleteDiarioObra(IdDiarioObras: number): Promise<void> {
    
    await this.repository.deleteDiarioObra(IdDiarioObras);
  }
}
